module.exports = __webpack_public_path__ + "static/media/javascript.bb15d406b75226912905bdfb53627b16.svg";